<template>
  <div>
    <video ref="videoPlayer" class="video-js" controls></video>
  </div>
</template>

<script>
import videojs from "video.js";

export default {
  name: "DemoLiveStream",
  data() {
    return {
      player: undefined,
      streamList: [],
      isoLangList: [],
      langList: ["eng", "deu", "spa", "fra", "zho"],
    };
  },
  mounted: async function () {
    this.player = videojs(
      this.$refs.videoPlayer,
      {
        html5: {
          vhs: {
            overrideNative: !videojs.browser.IS_SAFARI,
          },
          nativeAudioTracks: false,
          nativeVideoTracks: false,
        },
        liveui: true,
        loop: true,
        autoplay: "any",
      },
      () => {
        this.player.fluid(true);
        this.player.aspectRatio("16:9");
        // Get the current player's AudioTrackList object.
        var audioTrackList = this.player.audioTracks();
        // Listen to the "change" event.
        audioTrackList.addEventListener("change", () => {
          // Log the currently enabled AudioTrack label.
          for (var i = 0; i < audioTrackList.length; i++) {
            var track = audioTrackList[i];
            if (track.enabled) {
              const lastPlayedTime = this.player.currentTime();
              this.player.src({
                type: "video/mp4",
                src: this.streamList[track.id],
              });
              this.player.currentTime(lastPlayedTime);
              this.player.play();
              return;
            }
          }
        });
        let src = "https://d5ctfdkd106fc.cloudfront.net/eng-demo.mp4";
        this.player.src({ type: "video/mp4", src });
        this.player.play();
        this.init();

        // // Tweaking video-js caption button styles
        // let videoCaption = document.querySelector(".vjs-subs-caps-button");
        // videoCaption.style.setProperty("display", "block", "important");

        // videoCaption.addEventListener("click", function() {
        //   console.log("fooooooo");
        // });

        // videoCaption.addEventListener("mouseover", function() {
        //   let item = videoCaption.querySelector(".vjs-menu");
        //   if (item) item.parentNode.removeChild(item);
        // });
      },
    );
  },
  methods: {
    addTrack(data) {
      if (data.kind == "main") {
        data.enabled = true;
      }
      // Create a track object.
      const track = new videojs.AudioTrack(data);

      try {
        this.player.audioTracks().addTrack(track);
      } catch (e) {
        console.log("File: DemoLiveStream.vue, add track error: ", e);
      }
    },
    init() {
      setTimeout(() => {
        // Get the track we created in an earlier example.
        var track = this.player.audioTracks().getTrackById("default");

        try {
          // Remove it from the audio track list.
          this.player.audioTracks().removeTrack(track);
        } catch (error) {
          console.log("File: DemoLiveStream.vue, Could not remove track");
        }

        for (const lang of this.langList) {
          this.streamList[lang] = `https://d5ctfdkd106fc.cloudfront.net/${lang}-demo.mp4`;

          this.addTrack({
            id: lang,
            kind: lang == "eng" ? "main" : "translation",
            label: lang,
            language: lang,
          });
        }
      }, 1000);
    },
  },
};
</script>

<style src="video.js/dist/video-js.css"></style>
<style scoped>
.video-js {
  height: 100vh !important;
  width: 98% !important;
  padding-top: 0px !important;
  margin-left: auto;
  margin-right: auto;
}

video,
.video-js {
  outline: none !important;
}

.vjs-menu .vjs-menu-content {
  display: none !important;
}

.video-js .vjs-control-bar {
  display: none !important;
}
</style>
